// extracted by mini-css-extract-plugin
module.exports = {"filterGroup":"filter-group_filterGroup__2qMz7","left":"filter-group_left__34bwT","right":"filter-group_right__3qvcJ"};